module.exports = __webpack_public_path__ + "img/ogp_rubik_big.894ae95e.jpg";